import { Link } from "react-router-dom";
import {
  GAME_OPTIONS_PATH,
  HIDE_AND_SEEK_TUTORIAL_PATH,
} from "../../../../constants";
import "./SetUpBox.css";

const DIFFICULTIES = ["easy", "medium", "hard"];
const TIME_BY_DIFFICULTY = {
  easy: 60,
  medium: 45,
  hard: 30,
};

function capitalize(value) {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export default function SetUpBox({
  unit,
  category,
  onStartGame,
  difficulty,
  setDifficulty,
}) {
  return (
    <div className="hide-seek-setup-container">
      <Link
        to={HIDE_AND_SEEK_TUTORIAL_PATH}
        state={{ unit: unit, category: category }}
        className="hide-seek-help-link"
        aria-label="Open Hide and Seek tutorial"
      >
        <button type="button" className="hide-seek-help-button">
          ?
        </button>
      </Link>

      <h1>{unit.name}</h1>

      <div className="hide-seek-pregame-div">
        <h2>Hide and Seek Game</h2>

        <div className="hide-seek-settings-div">
          <b>Difficulty Level:</b>
          {DIFFICULTIES.map((difficultyOption) => (
            <div key={difficultyOption} className="hide-seek-difficulty-option">
              <input
                type="radio"
                id={`hide-seek-${difficultyOption}`}
                name="hide-seek-difficulty"
                value={difficultyOption}
                checked={difficultyOption === difficulty}
                onChange={(event) => setDifficulty(event.target.value)}
              />
              <label htmlFor={`hide-seek-${difficultyOption}`}>
                {capitalize(difficultyOption)} ({TIME_BY_DIFFICULTY[difficultyOption]}s)
              </label>
            </div>
          ))}
        </div>

        <button className="btn btn-primary" onClick={onStartGame}>
          Start Game
        </button>
      </div>

      <Link
        to={GAME_OPTIONS_PATH}
        state={{ unit: unit, category: category }}
        className="game-options-back-link"
      >
        <button className="btn btn-back game-options-back-button">Back</button>
      </Link>
    </div>
  );
}
